class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onMouseEnter() {
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = null;
    }
    // 1. 立即给 body 和 菜单加类
    document.body.classList.add('menu-active-blur');
    this.mainDetailsToggle.classList.remove('is-leaving');
    this.mainDetailsToggle.classList.add('is-hovered');
    
    // 2. 依然保留 open 属性以兼容主题结构，但动画不依赖它
    this.mainDetailsToggle.setAttribute('open', '');
    console.log("鼠标挪入")
  }

onMouseLeave(event) {
    // 检查鼠标移动到的新元素 (relatedTarget) 是否仍然在当前组件内部
    // 如果鼠标移向了菜单内部的内容，则不触发关闭逻辑
    if (this.contains(event.relatedTarget)) return;

    console.log("真实挪出组件外");
    
    this.mainDetailsToggle.classList.remove('is-hovered');
    this.mainDetailsToggle.classList.add('is-leaving');
    document.body.classList.remove('menu-active-blur');

    this.hoverTimer = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('is-leaving');
      this.hoverTimer = null;
    }, 300); 
  }

  close() {
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = null;
    }
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    // 4. 确保关闭时移除模糊
    document.body.classList.remove('body-menu-open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
